import styled, { DefaultTheme, useTheme } from "styled-components/native";
import React from "react";

import { Spacer, VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { SpaceType } from "@components/atoms/Spacer/types";
import { LabelContainerProps } from "./types";
import { Linking, Platform, TouchableOpacity, View } from "react-native";
import { DefaultThemeValueType } from "../../../../styled";
import { containsHTML } from "@scenes/findMatch/Utils/ProductDetailList/utils";
import RenderHTML from "react-native-render-html";
import { css } from "styled-components/native";
import * as Clipboard from "expo-clipboard";
import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { handleEmailClick } from "@utils/product/productValidators";
import { useTranslation } from "react-i18next";
import StrikePrice from "../StrikePrice";

const LabelView = ({
  rightIcon,
  leftIcon,
  rightIconTheme,
  leftIconTheme,
  itemLeftText,
  itemRightText,
  leftPostfixText,
  rightPrefixText,
  rightPostfixText,
  //isFixedKeyWidth,
  keyWidthPercent,
  rightPrefixTextTheme,
  direction = "row",
  keyTypographyStyle,
  valueTypographyStyle,
  cellWidth,
  keyWidth,
  ellipsize = true,
  containerJustifyContent = "flex-start",
  itemLeftTextTheme,
  rightIconSize,
  rightIconAlign,
  clickableHandle,
  emailClickable,
  availabilityIcon,
  keyMarginBottom,
  valueWidthPercent,
  isFixWidth,
  hasExtraSpace = false,
  marginRightValue = 0,
  selectableRightValue = true,
  leftIconSpace = SpaceType.Basic,
  allowSpaceAfterLeftText = true,
  isFromMatchPair,
  itemRightView,
  marginRight = 0,
  alignRightLabel,
  valueTextDecoration,
  countryCode,
  valueWidth,
  showKeyTruncate,
  strikeThrough,
  specialPrice,
  rightIconSpecial,
  rightIconSizeSpecial,
  rightIconThemeSpecial,
  onPhoneClick,
  alignKeyTop = false,
}: LabelContainerProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleDialer = async (dialerText?: string) => {
    onPhoneClick?.();
    if (dialerText !== "-" && dialerText) {
      if (Platform.OS === "web") {
        const facetimeURL = `facetime://${dialerText}`;
        try {
          const canOpenFacetime = await Linking.canOpenURL(facetimeURL);
          if (canOpenFacetime) {
            await Linking.openURL(facetimeURL);
            return;
          }
        } catch (error) {}

        const telURL = `tel:${dialerText}`;
        try {
          const canOpenTel = await Linking.canOpenURL(telURL);
          if (canOpenTel) {
            await Linking.openURL(telURL);
            return;
          }
        } catch (error) {}

        await Clipboard.setStringAsync(dialerText);
        showToast(
          "global.titleText.success",
          "global.titleText.mobileCopied",
          ToastTypes.SUCCESS,
          true,
          true
        );
      } else if (Platform.OS === "ios") {
        await Linking.openURL("telprompt: " + dialerText);
      } else {
        await Linking.openURL("tel: " + dialerText);
      }
    }
  };

  return (
    <ContainerView
      justifyContent={containerJustifyContent}
      direction={direction}
      isFixWidth={isFixWidth}
      alignKeyTop={alignKeyTop}
    >
      <LeftLabelContainer
        keyWidthPercent={keyWidthPercent}
        keyWidth={keyWidth}
        keyMarginBottom={keyMarginBottom}
      >
        {leftIcon && (
          <VDBIcon
            name={leftIcon}
            size={24}
            color={leftIconTheme ? leftIconTheme : theme["main-01"]}
            variant={IconsVariant.VDBCustom}
          />
        )}
        {leftIcon && <Spacer size={leftIconSpace} />}
        {itemLeftText && (
          <VDBText
            type={keyTypographyStyle}
            color={itemLeftTextTheme ? itemLeftTextTheme : theme["core-06"]}
            selectable={Platform.OS === "web"}
            {...(showKeyTruncate
              ? { numberOfLines: 1, ellipsizeMode: "tail" }
              : {})}
          >
            {itemLeftText}
          </VDBText>
        )}
        {leftPostfixText && allowSpaceAfterLeftText && (
          <Spacer size={SpaceType.Tiny} />
        )}
        {leftPostfixText && (
          <VDBText
            type={keyTypographyStyle}
            color={theme["core-06"]}
            selectable={Platform.OS === "web"}
          >
            {leftPostfixText}
          </VDBText>
        )}
      </LeftLabelContainer>
      {itemLeftText && (
        <Spacer
          size={
            theme.isMobile && !hasExtraSpace
              ? SpaceType.Tiny
              : SpaceType.ExtraSmall
          }
        />
      )}
      <RightLabelContainer
        isFixWidth={isFixWidth}
        alignRightLabel={alignRightLabel}
        valueWidth={valueWidth}
        valueWidthPercent={valueWidthPercent}
      >
        {rightPrefixText && (
          <VDBText
            type={valueTypographyStyle}
            color={theme["core-05"]}
            selectable={Platform.OS === "web"}
          >
            {rightPrefixText}
          </VDBText>
        )}
        {rightPrefixText && (
          <Spacer
            size={
              theme.isMobile && !hasExtraSpace
                ? SpaceType.Tiny
                : SpaceType.ExtraSmall
            }
          />
        )}
        <RightValueContainer
          cellWidth={cellWidth}
          valueWidthPercent={valueWidthPercent}
          marginRightValue={marginRightValue}
          isFromMatchPair={isFromMatchPair}
          strikeThrough={strikeThrough}
        >
          {itemRightText &&
            (specialPrice ? (
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <VDBIcon
                  name={rightIconSpecial}
                  size={rightIconSizeSpecial ? rightIconSizeSpecial : 24}
                  color={rightIconThemeSpecial}
                  variant={IconsVariant.VDBCustom}
                />
                <Spacer size={SpaceType.ExtraSmall} />
                <VDBText
                  type={valueTypographyStyle}
                  color={
                    rightPrefixTextTheme
                      ? rightPrefixTextTheme
                      : theme["link-static"]
                  }
                  numberOfLines={ellipsize ? 1 : 0}
                  ellipsizeMode="tail"
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  {itemRightText}
                </VDBText>
              </View>
            ) : strikeThrough ? (
              <StrikePrice
                value={itemRightText}
                textColor={theme["error-01"]}
                lineColor={theme["error-01"]}
                typography={valueTypographyStyle}
                align={"left"}
              />
            ) : clickableHandle || emailClickable ? (
              (() => {
                const hasMultiplePhones =
                  clickableHandle &&
                  !emailClickable &&
                  /[,;.]/.test(itemRightText) &&
                  itemRightText !== "-";

                if (hasMultiplePhones) {
                  const parts = itemRightText.split(/([,;.])/);

                  return (
                    <PhoneNumbersContainer>
                      {parts.map((part, index) => {
                        const trimmedPart = part.trim();

                        if (/^[,;.]$/.test(part)) {
                          return (
                            <VDBText
                              key={`sep-${index}`}
                              type={valueTypographyStyle}
                              color={theme["core-05"]}
                              style={{ paddingHorizontal: 2 }}
                            >
                              {part}
                            </VDBText>
                          );
                        }

                        if (trimmedPart && /\d/.test(trimmedPart)) {
                          const phoneWithCode = countryCode
                            ? `+${countryCode} ${trimmedPart}`
                            : trimmedPart;
                          return (
                            <TouchableOpacity
                              key={`phone-${index}`}
                              activeOpacity={0.8}
                              onPress={() => handleDialer(phoneWithCode)}
                              style={{
                                cursor:
                                  Platform.OS === "web" ? "pointer" : "auto",
                              }}
                            >
                              <VDBText
                                type={valueTypographyStyle}
                                isBold={true}
                                color={
                                  rightPrefixTextTheme
                                    ? rightPrefixTextTheme
                                    : theme["link-static"]
                                }
                                style={{ paddingTop: 0, paddingBottom: 0 }}
                                selectable={Platform.OS === "web"}
                                textDecoration={valueTextDecoration}
                              >
                                {phoneWithCode}
                              </VDBText>
                            </TouchableOpacity>
                          );
                        }

                        return null;
                      })}
                    </PhoneNumbersContainer>
                  );
                } else {
                  return (
                    <TouchableOpacity
                      activeOpacity={0.8}
                      onPress={() => {
                        if (emailClickable) {
                          handleEmailClick(t, itemRightText);
                        } else {
                          const phoneWithCode = countryCode
                            ? `+${countryCode} ${itemRightText}`
                            : itemRightText;
                          handleDialer(phoneWithCode);
                        }
                      }}
                      style={{
                        cursor: Platform.OS === "web" ? "pointer" : "auto",
                      }}
                    >
                      <VDBText
                        type={valueTypographyStyle}
                        isBold={true}
                        color={
                          rightPrefixTextTheme
                            ? rightPrefixTextTheme
                            : theme["link-static"]
                        }
                        numberOfLines={ellipsize ? 1 : 0}
                        ellipsizeMode="tail"
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                        selectable={Platform.OS === "web"}
                        textDecoration={valueTextDecoration}
                      >
                        {emailClickable
                          ? itemRightText
                          : countryCode
                          ? `+${countryCode} ${itemRightText}`
                          : itemRightText}
                      </VDBText>
                    </TouchableOpacity>
                  );
                }
              })()
            ) : (
              <View style={{ marginRight: marginRight }}>
                {containsHTML(itemRightText ?? "") ? (
                  <RenderHTML
                    source={{
                      html: `${itemRightText}`,
                    }}
                    defaultTextProps={{
                      selectable: true,
                    }}
                    tagsStyles={{
                      body: {
                        ...valueTypographyStyle,
                        color: rightPrefixTextTheme
                          ? rightPrefixTextTheme
                          : theme["core-05"],
                      },
                    }}
                  />
                ) : (
                  <VDBText
                    type={valueTypographyStyle}
                    isBold={true}
                    color={
                      rightPrefixTextTheme
                        ? rightPrefixTextTheme
                        : theme["core-05"]
                    }
                    numberOfLines={ellipsize ? 1 : 0}
                    ellipsizeMode={ellipsize ? "tail" : "clip"}
                    selectable={selectableRightValue}
                    textDecoration={valueTextDecoration}
                  >
                    {itemRightText}
                  </VDBText>
                )}
              </View>
            ))}
          {itemRightView && itemRightView}
        </RightValueContainer>
        {availabilityIcon && <Spacer size={SpaceType.ExtraSmall} />}
        {availabilityIcon && (
          <AvailabilityView availability={availabilityIcon} />
        )}
        {rightPostfixText && (
          <VDBText
            type={valueTypographyStyle}
            color={theme["core-05"]}
            selectable={Platform.OS === "web"}
          >
            {rightPostfixText}
          </VDBText>
        )}
        {rightIcon && <Spacer size={SpaceType.Basic} />}
        {rightIcon && (
          <RightIconAlignView rightIconAlign={rightIconAlign}>
            <VDBIcon
              name={rightIcon}
              size={rightIconSize ? rightIconSize : 24}
              color={rightIconTheme}
              variant={IconsVariant.VDBCustom}
            />
          </RightIconAlignView>
        )}
      </RightLabelContainer>
    </ContainerView>
  );
};

const AvailabilityView = styled.View<{ availability?: DefaultThemeValueType }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ theme, availability }) =>
    theme[availability as keyof DefaultTheme] as string};
`;

const ContainerView = styled.View<{
  justifyContent: string;
  direction: string;
  isFixWidth?: boolean;
  alignKeyTop?: boolean;
}>`
  flex-direction: ${({ direction }) => direction || "row"};
  justify-content: ${({ justifyContent }) => justifyContent};
  max-width: 100%;
  ${({ alignKeyTop }) =>
    alignKeyTop &&
    css`
      align-items: flex-start;
    `}
`;
const LeftLabelContainer = styled.View<any>`
  flex-direction: row;
  align-items: center;
  ${(props) =>
    props.keyMarginBottom &&
    css`
      margin-bottom: ${props.keyMarginBottom}px;
    `};
  ${(props) =>
    props.keyWidth &&
    css`
      width: ${props.keyWidth}px;
    `};
  ${(props) =>
    props.keyWidthPercent &&
    css`
      width: ${props.keyWidthPercent}%;
    `};
`;

const RightLabelContainer = styled.View<{
  isFixWidth?: boolean;
  alignRightLabel?: string;
  valueWidth?: boolean;
  valueWidthPercent?: number;
}>`
  flex-direction: row;
  ${({ alignRightLabel }) =>
    css`
      align-items: ${alignRightLabel ? alignRightLabel : "center"};
    `};
  ${({ valueWidth }) =>
    valueWidth &&
    css`
      width: ${valueWidth}px;
    `}
  ${({ isFixWidth }) =>
    isFixWidth &&
    css`
      flex: 1;
    `}
  ${({ valueWidthPercent }) =>
    valueWidthPercent &&
    css`
      width: ${valueWidthPercent}%;
    `}
`;

const RightIconAlignView = styled.View<{ rightIconAlign?: boolean }>`
  ${({ rightIconAlign }) =>
    rightIconAlign &&
    css`
      justify-content: center;
    `}
`;

const RightValueContainer = styled.View<{
  cellWidth?: number;
  valueWidthPercent?: number;
  marginRightValue: number;
  isFromMatchPair: boolean;
  strikeThrough?: boolean;
}>`
  ${({ strikeThrough }) =>
    strikeThrough &&
    css`
      align-items: flex-start;
    `}
  ${({ cellWidth }) =>
    cellWidth &&
    css`
      width: ${cellWidth}px;
    `}
  margin-right: ${({ marginRightValue }) => marginRightValue}px;
  ${({ theme, valueWidthPercent }) =>
    (theme.isLargeScreen || valueWidthPercent) &&
    css`
      flex: 1;
    `};
  ${({ isFromMatchPair }) =>
    isFromMatchPair &&
    css`
      width: 100%;
    `}
`;

const PhoneNumbersContainer = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;
export default LabelView;
